/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AboutStepCard from "./AboutStepCard";
import { COLORS } from "./about.constants";

export default function AboutMadarSection() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const currentLang = i18n.language || "ar";
  const isArabic = currentLang.startsWith("ar");

  useEffect(() => {
    if (!i18n.isInitialized) return;
    i18n.reloadResources(currentLang);
  }, [currentLang, i18n.isInitialized]);

  const rawSteps = t("about.steps", { returnObjects: true });
  const steps = Array.isArray(rawSteps)
    ? rawSteps
    : [
      {
        title: isArabic ? "اختر نوع متجرك" : "Choose Store Type",
        desc: isArabic
          ? "ابدأ باختيار المجال الذي يناسب نشاطك التجاري."
          : "Start by selecting the store type that fits your business.",
      },
      {
        title: isArabic ? "صمّم متجرك" : "Customize Your Store",
        desc: isArabic
          ? "عدّل الألوان، القوالب، والخطوط بسهولة لتمثل علامتك."
          : "Easily adjust colors, templates, and fonts to match your brand.",
      },
      {
        title: isArabic ? "أطلق متجرك" : "Launch Your Store",
        desc: isArabic
          ? "ابدأ البيع مباشرة عبر الإنترنت بكل بساطة."
          : "Launch your store online and start selling instantly.",
      },
    ];

  return (
    <section
      id="about-section"
      className="py-5"
      style={{
        background: COLORS.gradient,
        direction: isArabic ? "rtl" : "ltr",
        fontFamily: "'Tajawal', 'Cairo', sans-serif",
        color: COLORS.textLight,
        textAlign: "center",
      }}
    >
      <div className="container">
        <h2
          className="fw-bold mb-4"
          style={{
            color: COLORS.gold,
            fontSize: "2.5rem",
            fontFamily: "'Cairo', sans-serif",
            fontWeight: 700,
          }}
        >
          {t("about.title")}
        </h2>

        <p
          className="mb-5"
          style={{
            maxWidth: 750,
            margin: "0 auto",
            fontSize: "1.1rem",
            lineHeight: 1.9,
            color: COLORS.textLight,
          }}
        >
          {t("about.desc")}
        </p>

        <div
          className="d-flex justify-content-center gap-4 flex-wrap"
          style={{ maxWidth: "1100px", margin: "0 auto" }}
        >
          {steps.map((step, i) => (
            <AboutStepCard
              key={i}
              index={i}
              title={step.title}
              desc={step.desc}
            />
          ))}
        </div>

        <div className="mt-5">
          <button
            className="btn fw-semibold px-5 py-3"
            style={{
              background: COLORS.gold,
              color: COLORS.darkPurple,
              borderRadius: "10px",
              fontSize: "1.1rem",
              border: "none",
              transition: "0.3s ease",
            }}
            onClick={() => navigate("/login")}
          >
            {t("about.button")}
          </button>
        </div>
      </div>
    </section>
  );
}
